import { gql, useMutation } from '@apollo/client';

import {
  SetAgentNoteForParn,
  SetAgentNoteForParnVariables,
} from '../../../graphql/athena/mutations/__generated__/SetAgentNoteForParn';

export const SET_AGENT_NOTE_FOR_PARN = gql`
  mutation SetAgentNoteForParn($parnId: String!, $note: String!) {
    odProtosListingsServicesPartneragentreferralnetwork {
      setAgentNoteForPARN(input: { parnId: $parnId, note: $note }) {
        _empty
      }
    }
  }
`;

/**
 * Allows the setting of note details on an agent's lead
 */
export const useSetAgentNoteForParn = () => {
  const [setAgentNoteForParnMutation, { data, error, loading }] = useMutation<
    SetAgentNoteForParn,
    SetAgentNoteForParnVariables
  >(SET_AGENT_NOTE_FOR_PARN, {
    fetchPolicy: 'no-cache',
    context: {
      clientName: 'athena',
    },
  });

  const setAgentNoteForParn = (parnId: string, note: string) =>
    setAgentNoteForParnMutation({
      variables: { parnId, note },
    });
  return { setAgentNoteForParn, data, loading, error };
};
